<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName || headInfo.purorgId"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'DeliveryDueModifyBaseInfo',
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
